import { Trash } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";
import { showUnassignConfirmation as showUnassignUserRoleConfirmation } from "views/Account/Settings/User/Roles/UnassignConfirmation";
import { showUnassignConfirmation as showUnassignIdpGroupRoleConfirmation } from "views/Account/Settings/IdpGroup/AssignRoleDrawer/UnassignConfirmation";
import { showUnassignConfirmation as showUnassignApiKeyRoleConfirmation } from "views/Account/Settings/ApiKey/UnassignConfirmation";
import { showStackRoleUnassignConfirmation } from "shared/Stack/Roles/UnassignConfirmation";
import useTypedContext from "hooks/useTypedContext";
import { SettingsContext } from "views/Account/Settings/Context";
import { AnalyticsPageOrganization } from "hooks/useAnalytics/pages/organization";

import { CellComponentProps, EntityType } from "../types";
import { ANALYTICS } from "../../constants";

type RoleUsedByListItemDeleteActionsCellProps = CellComponentProps;

const RoleUsedByListItemDeleteActionsCell = ({
  entity,
  roleName,
  readOnly,
}: RoleUsedByListItemDeleteActionsCellProps) => {
  const { activationStatus } = useTypedContext(SettingsContext);

  if (readOnly) {
    return null;
  }

  const onDelete = () => {
    switch (entity.type) {
      case EntityType.User:
        showUnassignUserRoleConfirmation({
          id: entity.roleBindingId,
          name: roleName,
          isLastRole: entity.isLastRole,
        });
        break;
      case EntityType.UserGroup:
        showUnassignIdpGroupRoleConfirmation({
          id: entity.roleBindingId,
          name: roleName,
          isLastRole: entity.isLastRole,
          refetchQueries: ["GetRole"],
          activationStatus,
        });
        break;
      case EntityType.ApiKey:
        showUnassignApiKeyRoleConfirmation({
          id: entity.roleBindingId,
          name: roleName,
          isLastRole: entity.isLastRole,
          refetchQueries: ["GetRole"],
          activationStatus,
        });
        break;
      case EntityType.Stack:
        showStackRoleUnassignConfirmation({
          id: entity.roleBindingId,
          name: roleName,
          refetchQueries: ["GetRole"],
          source: "table",
          analyticsPage: AnalyticsPageOrganization.OrganizationRoleUsedBy,
        });
        break;
    }
  };

  return (
    <ButtonIcon
      {...ANALYTICS}
      variant="dangerSecondary"
      analyticsTitle="Delete clicked"
      icon={Trash}
      onPress={onDelete}
    >
      Delete
    </ButtonIcon>
  );
};

export default RoleUsedByListItemDeleteActionsCell;
